import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
//import TemplateBasePage from "../TemplateBasePage";  // 正式
import TemplateBasePage from "./FakeTemplateBasePage"; // 模擬
import styles from './styles.module.scss';
import './fonts.scss';

import Resource from "./assets/resource.jpg";

class TemplatePage extends TemplateBasePage {

  render() {
    return (
      <>
        <Helmet>
          <title>範例 | sandshour 散時間 - 影音內容訂閱平台</title>
        </Helmet>
        <div className={styles.pageContainer}>
          {
            /* 內容放這裡 */
            <>
              <img className={styles.upperImage} src={Resource}/>
              <div>Hello World</div>
              <button onClick={() => this.onSubscriptionBtnClick('Yearly')}>年訂閱</button>
            </>
          }

          {this.renderBase()}
        </div>
      </>
    );
  }
}

export default TemplatePage;
